import styled, { css } from 'styled-components';
import store from '@/store';
import { SMARTPHONE } from '@/constants';

export const WizardPageWrapper = styled.div`
  width: 100%;
  height: 100%;
  font-family: Lato;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: ${props => props.gridTemplateRows || '80px 1fr 70px 0'};
  font-size: 16px;

  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css`
          grid-template-columns: 1fr;
          grid-template-rows: ${props.isLastWizardPage ? '80px 1fr 130px 0' : '80px 1fr 65px 0'};
        `;
      }
      default: {
        return null;
      }
    }
  }}
`;

export const Header = styled.div`
  grid-row: 1/2;
  grid-column: 1/4;
  background-color: #f4f4f4;
  box-shadow: 0 1px 15px 0 rgba(0, 0, 0, 0.2);
  z-index: 103;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 5px 0 0 0;

  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css`
          grid-column: 1/3;
        `;
      }
      default: {
        return null;
      }
    }
  }}
`;

export const RendererWrapper = styled.div`
  grid-row: ${props => (props.gridRow || '2/3')};
  grid-column: ${props => (props.gridColumn || '1/3')};
  overflow: hidden;

  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css`
          grid-column: 1/3;
        `;
      }
      default: {
        return null;
      }
    }
  }}
`;

export const Footer = styled.div`
  grid-row: ${props => props.gridRow || '3/4'};
  grid-column: ${props => (props.gridColumn || '1/4')};
  background-color: ${props => props.backgroundColor || '#ffffff'};
  box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.2);
  z-index: 103;
  overflow-x: auto;
  overflow-y: hidden;
  
  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css`
          display: flex;
          width: 100%;
          height: ${props => props.isLastWizardPage? '130px' : '65px'};
        `;
      }
      default: {
        return null;
      }
    }
  }}
`;
